import Slice9Panel from "../../../../../../../shared/lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import BalloonView from "./BalloonView";

export default class NPCBalloonView extends BalloonView {

    constructor(target) {
        super(target);

        const bitmap = target.children.find(c => c instanceof createjs.Bitmap);
        this._slice9Panel = new Slice9Panel(target, bitmap, { mode: Slice9Panel.VERTICAL });
    }

    setText(text, animate) {
        super.setText(text, animate);
        this._slice9Panel.update();
    }
}
